<template>
  <div class="ad-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="优惠活动"
      left-arrow
      @click-left="onTopClickLeft"
      class="custom-navbar"
    >
      <template #right>
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          class="home-link"
        >
          <van-icon name="wap-home" size="20" />
        </a>
      </template>
    </van-nav-bar>

    <!-- 广告图片展示区 -->
    <div class="ad-container">
      <!-- 标题区域 -->
      <div class="ad-header">
        <div class="header-badge">
          <van-icon name="fire" class="badge-icon" />
          <span>限时优惠</span>
        </div>
        <h2 class="header-title">星耀未来专属福利</h2>
        <p class="header-subtitle">长按识别二维码，领取专属优惠券</p>
      </div>

      <!-- 广告图片卡片 -->
      <div class="ad-card">
        <div class="card-glow"></div>
        <div class="ad-image-wrapper">
          <img
            class="ad-image"
            src="https://www.ptty.com.cn/wap/xywlAdYxq.jpg"
            alt="优惠活动"
          />
          <!-- 装饰元素 -->
          <div class="corner-decoration top-left"></div>
          <div class="corner-decoration top-right"></div>
          <div class="corner-decoration bottom-left"></div>
          <div class="corner-decoration bottom-right"></div>
        </div>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "AdIndex",

  data() {
    return {
      routeValue: ""
    };
  },

  created() {
    this.utilPost = this.$util.handler;
  },

  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
  },

  methods: {
    onTopClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.ad-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
  padding-bottom: 40px;
}

.custom-navbar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.home-link {
  display: flex;
  align-items: center;
  color: #333;
  text-decoration: none;
}

/* 广告容器 */
.ad-container {
  padding: 0 16px;
}

/* 标题区域 */
.ad-header {
  text-align: center;
  padding: 24px 0 20px;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ff4444 100%);
  border-radius: 20px;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
  animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(255, 68, 68, 0.4);
  }
}

.badge-icon {
  font-size: 16px;
  animation: fireFlicker 1.5s ease-in-out infinite;
}

@keyframes fireFlicker {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.1) rotate(-5deg);
  }
  75% {
    transform: scale(1.1) rotate(5deg);
  }
}

.header-title {
  margin: 16px 0 8px;
  font-size: 24px;
  font-weight: 700;
  color: #333;
  letter-spacing: 1px;
}

.header-subtitle {
  margin: 0;
  font-size: 14px;
  color: #666;
}

/* 广告卡片 */
.ad-card {
  position: relative;
  margin: 20px 0;
  padding: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.card-glow {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  opacity: 0.5;
  filter: blur(10px);
  z-index: -1;
  animation: glowPulse 3s ease-in-out infinite;
}

@keyframes glowPulse {
  0%,
  100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.02);
  }
}

.ad-image-wrapper {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.ad-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 装饰角 */
.corner-decoration {
  position: absolute;
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.8);
}

.corner-decoration.top-left {
  top: 12px;
  left: 12px;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 8px;
}

.corner-decoration.top-right {
  top: 12px;
  right: 12px;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 8px;
}

.corner-decoration.bottom-left {
  bottom: 12px;
  left: 12px;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 8px;
}

.corner-decoration.bottom-right {
  bottom: 12px;
  right: 12px;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 8px;
}

/* 信息卡片区域 */
.info-section {
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.info-card:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.info-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
  border-radius: 12px;
  flex-shrink: 0;
}

.info-content {
  flex: 1;
}

.info-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-desc {
  margin: 0;
  font-size: 13px;
  color: #999;
}

/* 温馨提示 */
.tips-section {
  margin: 24px 0;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  border-left: 4px solid #ff4444;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.tips-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.tips-list {
  margin: 0;
  padding-left: 20px;
  list-style: none;
}

.tips-list li {
  position: relative;
  margin: 8px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.tips-list li::before {
  content: "•";
  position: absolute;
  left: -15px;
  color: #ff4444;
  font-weight: 700;
}

/* 响应式优化 */
@media (max-width: 375px) {
  .ad-container {
    padding: 0 12px;
  }

  .header-title {
    font-size: 20px;
  }

  .info-card {
    padding: 12px;
  }

  .info-icon {
    width: 40px;
    height: 40px;
  }
}

/* 加载动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ad-header,
.ad-card,
.info-card,
.tips-section {
  animation: fadeIn 0.6s ease-out;
}

.info-card:nth-child(1) {
  animation-delay: 0.1s;
}

.info-card:nth-child(2) {
  animation-delay: 0.2s;
}

.info-card:nth-child(3) {
  animation-delay: 0.3s;
}

.tips-section {
  animation-delay: 0.4s;
}
</style>



// WEBPACK FOOTER //
// src/components/AdIndex/AdIndex.vue